import { render, staticRenderFns } from "./SingleUserBody.vue?vue&type=template&id=db580bb0&scoped=true&"
import script from "./SingleUserBody.vue?vue&type=script&lang=js&"
export * from "./SingleUserBody.vue?vue&type=script&lang=js&"
import style0 from "./SingleUserBody.vue?vue&type=style&index=0&id=db580bb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db580bb0",
  null
  
)

export default component.exports